import React, { useRef, useEffect, useState } from "react";
import Admin_Form from "views/Components/ServicesOperationComponent/Admin/Admin_Form";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/system";

const ServiceOperationPage = ({ id }) => {
  const divRef = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    // size update
    const updateSize = () => {
      if (divRef.current) {
        const { width, height } = divRef.current.getBoundingClientRect();
        console.log(width, height);
        setSize({ width, height });
      }
    };

    // set initial size
    updateSize();

    window.addEventListener("resize", updateSize);

    // remove event controller
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const theme = createTheme({
    typography: {
      fontFamily: '"Montserrat", sans-serif',
    },
  });

  return (
    <div style={mainDiv} ref={divRef}>
      <ThemeProvider theme={theme}>
        <Admin_Form id={id} />
      </ThemeProvider>
    </div>
  );
};

export default ServiceOperationPage;

const mainDiv = {
  height: "100%",
  border: "0px solid black",
};

const mainCard = {
  height: "100%",
  border: "0px solid red",
  fontFamily: "Montserrat, sans-serif",
};
